import clsx from 'clsx'

import { FvButton, Icon } from '@fv/client-components'

import { ShipperTooltip } from '@/components/ShipperTooltip'

import { canAccessMessages } from './hooks'
import { MessagesApp } from './MessagesApp'
import { useMessagesPanel } from './MessagesPanelProvider'
import { useUnreadMessageCount } from './queries'

export const MessagesNavLink = () => {
  const { isPanelOpen, togglePanel, closePanel } = useMessagesPanel()
  const unreadQuery = useUnreadMessageCount()
  const enabled = canAccessMessages()

  const unreadMessageCount = !unreadQuery.data
    ? 0
    : unreadQuery.data?.quoting + unreadQuery.data?.booked

  if (!enabled) {
    return null
  }

  if (unreadQuery.isLoading) {
    return <Icon icon="spinner" />
  }

  return (
    <>
      <ShipperTooltip label={`${unreadMessageCount} unread spot quote threads`}>
        <FvButton
          onClick={togglePanel}
          buttonTextClass="flex items-center"
          className={clsx('flex items-center group shrink-0', {
            ' bg-fv-beer-xlight border-2 border-fv-beer-dark rounded-md hover:bg-fv-blue-50 hover:border-fv-blue overflow-hidden':
              unreadMessageCount > 0,
          })}
        >
          <Icon
            icon="comment-alt-dots"
            transform="up-1.25"
            className={clsx('block group-hover:text-fv-gray-dark', {
              'bellshake-animation text-fv-beer-dark  group-hover:animate-none group px-2':
                unreadMessageCount > 0,
            })}
          />
          {unreadMessageCount > 0 && (
            <div className="text-xs font-semibold group-hover:bg-fv-blue-200 bg-fv-green-100 p-2 border-l border-fv-green-300 group-hover:border-fv-blue ">
              {unreadMessageCount}
            </div>
          )}
        </FvButton>
      </ShipperTooltip>
      <MessagesApp open={isPanelOpen} onClose={closePanel} />
    </>
  )
}
